import { RequestParameterTypeEnum } from "../Enums/RequestParameterTypeEnum";
import { RequestFieldDto } from "../Schemas/RequestFieldDto";
import { RequestPoistkaDto } from "../Schemas/RequestPoistkaDto";
import { RequestTypeDto } from "../Schemas/RequestTypeDto";
import { Request } from "./mappers";

export const filterContractsBasedOnOdvetvie = (requestType: RequestTypeDto, contracts: RequestPoistkaDto[]) => {
    return contracts.filter(function (contract) {
        if (requestType.odvetvia != null && requestType.odvetvia.length > 0) {
            let hasBlacklistedOdvetvie = false;
            let hasWhitelistedOdvetvie = false;
            let hasNullOdvetvie = false;

            for (let i = 0; i < requestType.odvetvia.length; i++) {
                let odvetvie = requestType.odvetvia[i];

                if (odvetvie.isBlacklist === null) {
                    hasNullOdvetvie = true;
                } else {
                    if (odvetvie.isBlacklist) {
                        if (odvetvie.odvetvieId === contract.odvetvieId) {
                            hasBlacklistedOdvetvie = true;
                        }
                    } else {
                        if (odvetvie.odvetvieId === contract.odvetvieId) {
                            hasWhitelistedOdvetvie = true;
                        }
                    }
                }
            }

            if (hasBlacklistedOdvetvie) {
                return false;
            } else if (hasWhitelistedOdvetvie || hasNullOdvetvie) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    });
}

export const getFieldsWithType = (selectedRequest: Request, type: RequestParameterTypeEnum) => {
    return selectedRequest.fields.filter((fld: RequestFieldDto) => fld.type === type) || [];
}
